<div class="form-group">
    @if (labelText) {
        <label for="dateInput"> {{ labelText }}</label>
    }
    <input
        #dateInput
        matInput
        [attr.id]="inputElementId ? inputElementId : null"
        [value]="selectedDate"
        (dateChange)="dateChanged($event.value)"
        [matDatepicker]="datepicker"
    />
    <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
    <mat-datepicker #datepicker></mat-datepicker>
</div>
